import { useLocation, useNavigate } from "react-router-dom";
import { EventConstants } from "utils/constants";
import { EventHelper, UrlHelper } from "utils/helpers";

function useOnSalaryPaymentViewInfo() {
  const location = useLocation();
  const navigate = useNavigate();

  const onViewButtonClick = () => {
    navigate(UrlHelper.formatPath(`/Employees/Salaries`), {
      state: { background: location },
    });
    EventHelper.publishEvent(EventConstants.CloseDrawer);
  };

  return onViewButtonClick;
}

export default useOnSalaryPaymentViewInfo;
